import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface LocationUsageTrackPayload {
  company_id?: number | string | null;
  session_id?: string | null;
  area?: string | null;
  type?: string | null;
  action: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocationUsageService {
  private readonly apiUrl = this.normalizeBaseUrl(environment.apiUrl || '/api');
  private readonly sessionStorageKey = 'visualizer_session_id';

  constructor(private http: HttpClient) {}

  track(payload: LocationUsageTrackPayload): Observable<any> {
    return this.http.post(`${this.apiUrl}/location-usages/track`, {
      ...payload,
      session_id: payload.session_id || this.getSessionId()
    }).pipe(
      catchError(() => EMPTY)
    );
  }

  getSessionId(): string {
    try {
      const existing = localStorage.getItem(this.sessionStorageKey);

      if (existing) {
        return existing;
      }

      const nextId = this.createSessionId();
      localStorage.setItem(this.sessionStorageKey, nextId);

      return nextId;
    } catch {
      return this.createSessionId();
    }
  }

  private createSessionId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }

    return `visualizer-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  }

  private normalizeBaseUrl(value: string): string {
    return String(value || '').replace(/\/+$/, '');
  }
}
